
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.679 8.897h-3.34c-.991-.813-1.656-1.935-1.656-3.66 0-3.333 2.644-5.195 5.902-5.195 2.724 0 5.62 1.083 5.62 3.089v.888a.54.54 0 01-.54.542h-.481a.54.54 0 01-.54-.542v-.49c0-1.435-2.621-2.004-4.06-2.004-2.353 0-4.313 1.183-4.313 3.569 0 2.105 1.46 2.995 3.408 3.803zm11.782 2.168H.539A.54.54 0 010 10.523v-.362c0-.299.241-.542.54-.542h21.92a.54.54 0 01.54.542v.362a.54.54 0 01-.54.542zm-8.95.722c1.531.799 2.615 1.851 2.615 3.749 0 2.604-2.065 3.939-4.71 3.939-1.935 0-4.57-.801-4.57-2.744v-.428a.54.54 0 00-.539-.542h-.482a.54.54 0 00-.539.542v.712c0 2.714 3.44 3.943 6.13 3.943 3.53 0 6.298-2.106 6.298-5.593 0-1.613-.534-2.733-1.375-3.578H13.51z","fill":"#262626"}})])
          )
        }
      }
    